// Wave Q — operational empty state (Premium-SaaS redesign, 2026-06-10).
//
// The original EmptyState (still kept for back-compat — many tabs use
// it) shows an illustration + title + body + action. That's friendly
// but not operational: it doesn't tell the operator *why* the state
// matters or *what to do first*.
//
// OperationalEmpty enforces the brief's five-slot pattern:
//
//   1. caption        — eyebrow tag (sentence-case, "Proof vault" · "empty")
//   2. title          — what's missing (sentence-case)
//   3. why            — why it matters (sentence-case)
//   4. recommendation — concrete first action / example
//   5. actions        — primary + secondary CTAs
//
// Use this on every list-empty state. The original EmptyState stays
// for transient "no recent activity" panels where the heavy treatment
// would be overkill.

export function OperationalEmpty({
  caption,
  title,
  why,
  recommendation,
  recommendationLabel = 'Recommended',
  actions,
  className,
}) {
  return (
    <section
      className={['studio-op-empty', className].filter(Boolean).join(' ')}
      role="region"
      aria-label={title || 'Empty state'}
    >
      {caption ? (
        <div className="studio-op-empty-caption">{caption}</div>
      ) : null}
      {title ? <h2 className="studio-op-empty-title">{title}</h2> : null}
      {why ? <p className="studio-op-empty-why">{why}</p> : null}
      {recommendation ? (
        <div className="studio-op-empty-recommendation">
          <span className="studio-op-empty-recommendation-label">
            {recommendationLabel}
          </span>
          <span>{recommendation}</span>
        </div>
      ) : null}
      {actions ? (
        <div className="studio-op-empty-actions">{actions}</div>
      ) : null}
    </section>
  )
}
